"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'pic2',
  data: function data() {
    return {
      srcurl: '',
      // 预览下载的图片地址
      list: [],
      dialogVisible: false,
      dialogVisibles: false,
      dialogImageUrl: '',
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      filePaths: [],
      imgUrls: [],
      fileList: []
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'filesUploadApi'])),
  created: function created() {
    //this.datalist();//调用数据
    this.clearImgs();
  },
  methods: {
    // 获取数据

    /*async datalist() {
      this.list=["https://img2.baidu.com/it/u=3286061922,1160551693&fm=26&fmt=auto","https://img2.baidu.com/it/u=3286061922,1160551693&fm=26&fmt=auto"]
    },*/
    clearImgs: function clearImgs() {
      this.filePaths = [];
      this.fileList = [];
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      console.log('handleSuccess');
      console.log(response);
      console.log(this.fileList);
      this.filePaths.push(JSON.stringify(response));
      this.$emit('uploadSuccess', this.filePaths);
    },
    // 删除图片
    handleRemove: function handleRemove(file, fileList) {
      console.log('handleRemove');
      console.log(file);

      for (var i = 0; i < this.filePaths.length; i++) {
        var o = eval('(' + this.filePaths[i] + ')');

        if (o.realName === file.response.realName) {
          this.filePaths.splice(i, 1);
          break;
        }
      }

      this.$emit('delSuccess', this.filePaths);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisibles = true;
    }
  }
};
exports.default = _default;